import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './Routes';
import routerChecks from './RouterChecks';

Vue.use(VueRouter);

const router = new VueRouter({
  ...routes,
  mode: 'history',
});

routerChecks(router);

export default router;
